<template>
  <GenericDataView
    v-slot="{id, loading, isUpdateForm}"
    title="Labor Components"
    local-storage-key="laborComponents"
    :state="laborComponents"
    :read="laborComponentsStore.readLaborComponents"
    :set="laborComponentsStore.setLaborComponents"
    :delete="laborComponentsStore.deleteLaborComponent"
    :cols-map="colsMap"
    :cached="cached"
    @cached="cached = true"
  >
    <LaborComponentForm :id="id" :loading="loading" :is-update-form="isUpdateForm" />
  </GenericDataView>
</template>
<script setup lang="ts">
import {LaborComponent} from '@/stores/userManagement/userManagement';

const laborComponentsStore = useLaborComponentsStore();
const {laborComponents} = storeToRefs(laborComponentsStore);
const cached = ref(false);

const colsMap = readonly<{[key: string]: keyof LaborComponent}>({
  'Labor Component': 'name',
  'Labor Description': 'description',
  'Estimated Time Labor': 'estimated_labor',
});
</script>
